<template>
  <section class="page-columns" :class="{bordered: bordered, reverse: reverse,column_full:column_full,column_half:column_half}">
    <div class="column column-first">
      <div class="column-inner">
        <slot name="first"/>
      </div>
    </div>
    <div class="column column-last">
      <div class="column-inner">
        <slot name="last"/>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    props: {
      bordered: {
        default: false,
      },
      reverse: {
        default: true,
      },
      column_full: {
        default: false,
      },
      column_half: {
        default: false,
      },
    },
  }
</script>

<style lang="scss">

  .page-columns {

    display: flex;display: -ms-flexbox;
    flex-flow: row nowrap;
    @media(max-width: $media_md) {
      flex-flow: column nowrap;
      &.reverse {
        flex-flow: column-reverse nowrap;
      }
    }
    &.column_half {
      .column-first {
        flex: 0 0 50%;
      }
      .column-last {
        flex: 0 0 50%;
      }
    }
    .column-first {
      flex: 0 0 40%;
    }
    .column-last {
      flex: 0 0 60%;
     }

    & > .column {


      @media(max-width: $media_md) {
        flex: 1 0 auto;
        width: 100%;
      }
      &:first-child {
        & > .column-inner {
          padding-right: 15px;
          @media(max-width: $media_md) {
            padding-right: 0;
          }
        }
      }
      &:last-child {
        & > .column-inner {
          padding-left: 15px;
          @media(max-width: $media_md) {
            padding-left: 0;
          }

        }
      }

      h3 {
        padding: 0 0 15px;
      }
      @media(max-width: $media_sm) {
        h3 {
          padding: 0;
        }
      }
    }
  }

  .column_full {
    flex-flow: column nowrap;
    & > .column {
      flex: 1 0 auto;
      width: 100%;
      &:first-child, &:last-child {
        & > .column-inner {
          padding-right: 90px;
          padding-left: 0;
          @media(max-width: $media_md) {
            padding-right: 0px;
          }
          @media(max-width: $media_sm) {
              padding: 0 40px;
          }
          @media(max-width: $media_xs) {
              padding: 0 15px;
          }
        }
      }
    }

  }
</style>



// WEBPACK FOOTER //
// components/shared/PageColumns.vue